export class VendPackageFilter {
    IncludeInactive?: boolean;
    IncludePackageConfigs?: boolean;
}

export default VendPackageFilter;